import { render, staticRenderFns } from "./AppSidebarUpgradeBadge.vue?vue&type=template&id=2c49c53a&scoped=true&lang=pug"
import script from "./AppSidebarUpgradeBadge.vue?vue&type=script&lang=ts"
export * from "./AppSidebarUpgradeBadge.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebarUpgradeBadge.vue?vue&type=style&index=0&id=2c49c53a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49c53a",
  null
  
)

export default component.exports